import Grid from '@mui/material/Grid';
import React, { useEffect, useRef, useState } from 'react';
import RenderingEngineOld from './widgets-future/RenderingEngine';

export default function EventCreationFuturePage() {
  const [size, setSize] = useState<any>(null);
  const cref = useRef<any>(null);

  useEffect(() => {
    // Calculate size of tree based on parent view port
    if (cref.current) {
      setSize({ width: cref.current.offsetWidth, height: cref.current.offsetHeight });
    } else {
      setSize(null);
    }
  }, [cref.current]);

  return (
    <Grid container direction="column" ref={cref} style={{ width: '100%', height: '100%', minHeight: '80vh', overflow: 'hidden', maxHeight: 'calc(100vh - 64px - 48px)' }}>
      {size && cref.current && <RenderingEngineOld {...size}/>}
    </Grid>
  );
}
